<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="temperatureCheckForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="temperatureCheck" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                temperatureCheckForm: () => import('../forms/TemperatureCheckForm'),
                temperatureCheck: () => import('../editViews/TemperatureCheck'),
                headers: [
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Facility', value: 'facilityId', table: 'facilities', form: () => import('../forms/FacilityForm') },
                    { text: 'Area Name', value: 'areaName' },
                    { text: 'Degrees Celsius', value: 'degreesCelsius' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    facilities: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "areaName", direction: "ascending" },
                    { column: "facilityId", direction: "ascending" },
                ],
                itemsField: 'temperatureChecks',
                editPageName: 'temperatureCheck',
                apiMethod: 'TemperatureChecks',
                claimName: 'TemperatureChecks',
                formTitle: 'Temperature Check',
                excelTitle: 'Temperature Checks',
                hasEditPage: true,
            }
        },
    };
</script>
